export default __webpack_public_path__ + "static/sugier-b7811e33bd289dbcdece816222df9765.jpg";